export default {"src":"/_next/static/media/WOLF.44e335b6.svg","height":18,"width":18};